import { Dialog, DialogContent, DialogTrigger } from "shared/ui/shadcn/dialog";

export const MarkdownComponentImg = (
  props: React.ImgHTMLAttributes<HTMLImageElement>
) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <img
          {...props}
          alt={props.alt || ""}
          referrerPolicy="no-referrer"
          className="cursor-pointer transition-transform duration-300 hover:scale-[1.02]"
        />
      </DialogTrigger>

      <DialogContent className="z-[51] min-h-[400px] min-w-[600px]">
        <img
          {...props}
          alt={props.alt || ""}
          referrerPolicy="no-referrer"
          className="h-full w-full object-contain"
        />
      </DialogContent>
    </Dialog>
  );
};
